var map = {
	"./IMG-20251019-WA0021.jpg": 9817,
	"./IMG-20251019-WA0022.jpg": 9550,
	"./IMG-20251019-WA0023.jpg": 7595,
	"./IMG-20251019-WA0024.jpg": 4504,
	"./IMG-20251019-WA0025.jpg": 5173,
	"./IMG-20251019-WA0026.jpg": 3098,
	"./IMG-20251019-WA0027.jpg": 839,
	"./IMG-20251019-WA0029.jpg": 4209,
	"./IMG-20251019-WA0030.jpg": 8171,
	"./IMG-20251019-WA0032.jpg": 3417,
	"./IMG-20251019-WA0033.jpg": 5372,
	"./IMG-20251019-WA0034.jpg": 6567,
	"./IMG-20251019-WA0039.jpg": 9846,
	"./IMG-20251019-WA0046.jpg": 2604,
	"./IMG-20251019-WA0048.jpg": 354,
	"./IMG-20251116-WA0016.jpg": 8413,
	"./IMG-20251116-WA0021.jpg": 6059,
	"./IMG-20251116-WA0071.jpg": 6124,
	"./IMG-20251116-WA0077.jpg": 4922,
	"./WhatsApp Image 2025-10-19 at 14.27.58_9962aa7d.jpg": 8156,
	"./WhatsApp Image 2025-10-19 at 14.27.58_e61c7589.jpg": 3321,
	"./WhatsApp Image 2025-11-16 at 14.37.11_2f99aae7.jpg": 9441,
	"./WhatsApp Image 2025-11-16 at 14.37.11_fb2a2f00.jpg": 3590,
	"./WhatsApp Image 2025-12-22 at 3.32.00 PM.jpeg": 2737
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5622;